'use strict';

import Tracking from "./tracking";

const axios = require('axios');
import {slideDown, slideUp} from "../utils/slideToggle";
import {WidgetInstance} from "friendly-challenge";
import Panier from "./panier";

const Form = {
    captchas: [],
    compareElements: false,
    init: function () {
        const forms = document.querySelectorAll('.c-form');
        if(forms){
            forms.forEach(form => {
                if (form) {
                    //init Recaptcha
                    if (form.querySelector('.frc-captcha')) {
                        Form.captchas[form.name] = new WidgetInstance(form.querySelector('.frc-captcha'));
                    }

                    let elements = form.querySelectorAll('.c-form__row-group input, .c-form__row-group textarea, .c-form__row-group select, input[type=hidden]');
                    elements.forEach(elm => Form.checkElementValidity(elm, form));

                    const submitButton = form.querySelector('.js-submit');
                    if (submitButton) {
                        submitButton.addEventListener('click', (e) => Form.checkFormBeforeSubmit(e, elements, form));
                    }
                }
            });
        }
    },
    checkElementValidity: function (el, form) {
        const globalError = form.querySelector('.error.global--');
        const globalSuccess = form.parentElement.querySelector('.c-info.success') || form.parentElement.parentElement.querySelector('.c-info.success');
        const parent = el.closest('.c-form__row-group');
        if (parent) {
            const elementError = parent.querySelector('.error');

            let eventList = ["change", "keyup", "paste", "input", "propertychange"];
            eventList.forEach(event => {
                el.addEventListener(event, () => {
                    slideUp(globalError);
                    if (el.name !== 'frc-captcha-solution') {
                        // Check if form fields are valid
                        if (el.dataset.compare && el.value !== "") {
                            Form.compareElements = true;
                        }

                        if (!el.validity.valid) {
                            Form.showError(el, elementError, form);
                        } else {
                            if (elementError)
                                elementError.textContent = '';
                            el.closest('.c-form__row-group').classList.remove('error');

                            if (el.dataset.compare) {
                                if (!Form.compareElements) {
                                    Form.showError(el, elementError, form);
                                } else {
                                    form.querySelectorAll('[data-compare="true"]').forEach(input => {
                                        const elementError = input.closest('.c-form__row-group').querySelector('.error');
                                        elementError.textContent = '';
                                        input.closest('.c-form__row-group').classList.remove('error');
                                    });

                                    // Comparison check
                                    const compareWith = el.dataset.compareWith;
                                    if (compareWith) {
                                        const compareElement = form.querySelector(`[name="${compareWith}"]`);
                                        if (compareElement && el.value !== compareElement.value) {
                                            Form.showError(el, elementError, form);
                                        }
                                    }
                                }
                            }
                        }
                    } else {
                        const element = form.querySelector('[name="frc-captcha-solution"]').closest('.c-form__row-group');
                        const elementError = element.querySelector('.error');
                        // Check if Friendly Captcha is filled
                        if (!el.value || el.value === ".UNSTARTED" || el.value === ".UNFINISHED" || el.value === ".FETCHING" || typeof el.value === "undefined") {
                            elementError.textContent = form.querySelector('.error-message-required').textContent;
                            element.classList.add('error');
                        } else {
                            if (element.classList.contains('error')) {
                                elementError.textContent = "";
                                element.classList.remove('error');
                            }
                        }


                    }
                    Form.checkFormValidity(form);
                });
            });
        }
    },
    checkFormValidity: function (form) {
        const allInputsValid = [...form.querySelectorAll("input, select, textarea")]
            .every(input => input.validity.valid);
        if (!allInputsValid) {
            return;
        }

        const api = form.dataset.api;
        if (api === "mailto") {
            const subject = form.dataset.object;
            const email = form.querySelector("[name='email']").value.trim();
            const emailContent = form.querySelector('.message').innerText.replace(/(<([^>]+)>)/ig, '');
            const submitButton = form.querySelector('.js-submit');
            submitButton.setAttribute('href', Form.mailToString(email, emailContent, subject));
        }
    },
    mailToString: function (email, emailContent, subject) {
        return "mailto:" + encodeURIComponent(email) + "?subject=" + encodeURIComponent(subject) + "&body=" + encodeURIComponent(emailContent);
    },
    showError: function (element, elementError, form) {
        if (element.validity.valueMissing) {
            // If the field is empty,
            // display the following error message.
            elementError.textContent = form.querySelector('.error-message-required').textContent;
        } else if (element.validity.typeMismatch) {
            // If the field doesn't contain an email address,
            // display the following error message.
            if (element.dataset.alphabet) {
                elementError.textContent = form.querySelector('.error-message-invalid-alphabet').textContent;
            } else if (element.type === 'email') {
                elementError.textContent = form.querySelector('.error-message-invalid-email').textContent;
            } else if (element.type === 'tel') {
                elementError.textContent = form.querySelector('.error-message-invalid-phone').textContent;
            } else {
                elementError.textContent = form.querySelector('.error-message-invalid').textContent;
            }
        } else if (element.validity.tooLong) {
            // If the data is too long,
            // display the following error message.
            elementError.textContent = form.querySelector('.error-message-toolong').textContent.replace('[MAXLENGTH]', element.dataset.maxlength);
        } else if (element.validity.tooShort) {
            // If the data is too short,
            // display the following error message.
            elementError.textContemnt = form.querySelector('.error-message-tooshort').textContent;
        } else if (element.validity.patternMismatch) {
            if (element.type === 'tel') {
                elementError.textContent = form.querySelector('.error-message-invalid-phone').textContent;
            } else {
                elementError.textContent = form.querySelector('.error-message-invalid').textContent;
            }
        } else if (element.dataset.compare) {
            elementError.textContent = form.querySelector('.error-message-compare').textContent;
        }

        // Set the styling appropriately
        element.closest('.c-form__row-group').classList.add('error');
    },
    checkFormBeforeSubmit: function (e, elements, form) {
        const submitButton = form.querySelector('.js-submit');
        const globalError = form.querySelector('.error.global--');
        let formData = new FormData();
        let err = [];
        let validArr = [];
        elements.forEach(el => {
            if (el.type === 'search' && el.classList.contains('choices__input')) {
                return;
            }
            if (el.name !== 'frc-captcha-solution' && el.name !== 'list' && el.type !== 'hidden') {
                if (el.closest('.c-form__row-group')) {
                    const elementError = el.closest('.c-form__row-group').querySelector('.error');
                    if (!el.validity.valid) {
                        // If it isn't, we display an appropriate error message
                        Form.showError(el, elementError, form);
                        err.push(el.name);
                        validArr.push(false);
                    } else {
                        if (el.dataset.compare) {
                            if (Form.compareElements === false) {
                                Form.showError(el, elementError, form);
                                validArr.push(false);
                                err.push(el.name);
                            }
                        }
                    }

                    // Append form data
                    switch (el.type) {
                        case 'radio':
                            if (el.checked) {
                                formData.append(el.name, el.id);
                            }
                            break;
                        case 'checkbox':
                            formData.append(el.name, el.checked ? el.value : 0);
                            break;
                        default:
                            formData.append(el.name, el.value);
                            break;
                    }
                }
            } else if (el.name === 'frc-captcha-solution') {
                const element = form.querySelector('[name="frc-captcha-solution"]').closest('.c-form__row-group');
                const elementError = element.querySelector('.error');
                const valueCaptcha = form.querySelector('[name="frc-captcha-solution"]').value;
                // Check if Friendly Captcha is filled
                if (!valueCaptcha || valueCaptcha === ".UNSTARTED" || valueCaptcha === ".UNFINISHED" || typeof valueCaptcha === "undefined") {
                    elementError.textContent = form.querySelector('.error-message-required').textContent;
                    element.classList.add('error');
                    err.push(el.name);
                    validArr.push(false);
                } else {
                    formData.append(el.name, valueCaptcha);
                }
            } else {
                formData.append(el.name, el.value);
            }
        });

        if (validArr.includes(false)) {
            slideDown(globalError);
            // Then we prevent the form from being sent by canceling the event
            e.preventDefault();
        } else {
            // Reset globalError text
            slideUp(globalError);
            const api = form.dataset.api;
            if (api !== 'mailto') {
                // Update submit button
                submitButton.classList.add('loading');
                // Post form data
                //console.log([...formData.entries()]);
                Form.submitForm(formData, form);
            }
        }

        if (form.getAttribute('name') === 'contact') {
            const subject = form.querySelector('#subject');
            Tracking.trackContactForm('submit', subject ? subject.value : '', validArr.includes(false), err.join(','));
        }
    },
    submitForm: function (formData, form) {
        const api = form.dataset.api;
        const submitButton = form.querySelector('.js-submit');
        const globalError = form.querySelector('.error.global--');
        const globalSuccess = form.parentElement.querySelector('.c-info.success') || form.parentElement.parentElement.querySelector('.c-info.success');
        axios({
            method: "post",
            url: api,
            data: formData,
            headers: {"Content-Type": "multipart/form-data"},
        }).then(function (response) {
            switch (response.data.code) {
                case 'all_good':
                    const userType = formData.get('category');
                    //console.log('success', response);
                    // Reset form
                    form.reset();
                    // Show message
                    if (form.getAttribute('name') === "download") {
                        const receiveType = formData.get('receive_type');
                        const successDownload = document.querySelector('.c-info.success-download');
                        const successPostal = document.querySelector('.c-info.success-postal');
                        if (receiveType === 'download') {
                            slideDown(successDownload);
                            const link = successDownload.querySelector('.c-button');
                            if(response.data.data.cta.url) {
                                link.setAttribute('href', response.data.data.cta.url);
                            }
                            if(response.data.data.cta.title) {
                                link.innerHTML = response.data.data.cta.title;
                            }
                            if(response.data.data.cta.filename){
                                link.setAttribute('title',response.data.data.cta.filename);
                            }
                        }
                        if (receiveType === 'postal') {
                            slideDown(successPostal);
                        }
                    } else {
                        slideDown(globalSuccess);
                    }
                    // Hide Form
                    slideUp(form);
                    // Scroll top
                    setTimeout(() => {
                        const top = globalSuccess.getBoundingClientRect().top + window.scrollY - 200;
                        window.scrollTo({top, behavior: "smooth"});
                    }, 400)
                    if (form.getAttribute('name') === "cart") {
                        Tracking.bindPurchaseTracking(Panier.items, userType, response.data.data.zoho_salesorder_id);
                        Panier.savePanier([])
                        Panier.renderPanier();
                        document.querySelector('.cart__empty')?.classList.remove('show--')
                    }
                    if (form.getAttribute('name') === 'contact') {
                        Tracking.trackContactForm('success', formData.get('subject'))
                    }
                    break;
                case 'error_mail':
                    console.log('error mail', response);
                    // Reset form
                    form.reset();
                    // Show global error
                    slideDown(globalError, 2000);
                    globalError.innerHTML = response.data.message + '<br/>' + response.data.data.errors.global;
                    break;
                case 'error_validation':
                    console.log('error validation', response);
                    // Show global error
                    slideDown(globalError);
                    Form.captchas[form.name].reset();
                    globalError.innerHTML = response.data.message;
                    // Handle Errors
                    if (response.data.data.errors) {
                        Form.handleErrors(response.data.data.errors, form);
                    }
                    break;
                case 'validator_failed':
                    console.log('error validation', response);
                    // Show global error
                    slideDown(globalError);
                    Form.captchas[form.name].reset();
                    globalError.innerHTML = response.data.message;
                    // Handle Errors
                    if (response.data.data.errors) {
                        Form.handleErrors(response.data.data.errors, form);
                    }
                    break;
                case 'error_db':
                    console.log('error db', response);
                    // Reset form
                    form.reset();
                    // Show global error
                    slideDown(globalError);
                    globalError.innerHTML = response.data.message + '<br/>' + response.data.data.errors.global;
                    break;
                case 'zoho_customer_save_failed':
                    console.log('error zoho', response);
                    // Reset form
                    form.reset();
                    // Show global error
                    slideDown(globalError);
                    globalError.innerHTML = response.data.message || 'Une erreur avec Zoho est survenue';
                    // Handle Errors
                    if (response.data.data.errors) {
                        Form.handleErrors(response.data.data.errors, form);
                    }
                    break;
            }
            // Reset submit button
            submitButton.classList.remove('loading');
        }).catch(function (response) {
            console.log('err', response);
            // Reset submit button
            Form.captchas[form.name].reset();
            submitButton.classList.remove('loading');
            // Show global error
            slideDown(globalError);
        });
    },
    handleErrors: function (errors, form) {
        let arrErrors = errors;
        if (!Array.isArray(errors)) {
            arrErrors = Object.entries(errors).map((e) => ({[e[0]]: e[1]}));
        }
        arrErrors.forEach(error => {
            Object.entries(error).forEach(([key, value]) => {
                // console.log(`Key: ${key}, Value: ${value}`);
                const el = form.querySelector(`[name="${key}"]`);
                const parent = el.closest('.c-form__row-group');
                parent.querySelector('.error').textContent = value;
                parent.classList.add('error');
            });
        });
    }
};

export default Form;